import React from "react";

import { SubmitButtonWrapper } from "./submitButton.styles";
import { SubmitButtonProps } from "./submitButton.interfaces";

export const SubmitButton: React.FC<SubmitButtonProps> = (props) => {
  return <SubmitButtonWrapper type="submit" value={props.text} />;
};
